/**
 *  
    import {navStore} from "@/store/nav.js";
    setup(){
        const nav = navStore();
        return {
        // 为了能在模板中使用它，你可以返回整个 Store 实例。
        nav
        }
    }
  
 * **/

import { defineStore, acceptHMRUpdate } from 'pinia'
import {getTopMenu,getRoutes} from "@/api/base.js";
import {setStore,getStore,removeStore,clearStore} from "@/util/store.js";


export const navStore = defineStore('nav', {
    
    state: () => ({
        topMenu:getStore({
            name: 'topMenu'
          }) || [], //主菜单
        childMenu:[],//子菜单
        currentChildMenu:0,
        isLoaderRouter:false,//是否获取了新的路由
        // 首次打开/跳转 noBind 前的页面地址（含 query），登录成功后可回跳
        firstOpenPath: '',
                
    }),
    getters: {
       
    },
    actions: {
        /**
         * 记录首次打开的页面路由地址
         * @param {string} path - 路由 fullPath
         */
        setFirstOpenPath(path) {
            this.firstOpenPath = path || '';
        },
        UpdateMenuInfo(){
            let that=this;
            getTopMenu().then(res=>{
                let {data} = res.data;
                that.topMenu = data;
                setStore({
                    name: 'topMenu',
                    content: data
                })
                console.log(res)
                that.getChildMenu();
            })
        },
        getChildMenu(){
            let that=this;
            getRoutes('95060110011').then(res=>{
                let {data} = res.data;
                that.childMenu = data;
            
                console.log('被调用了')
            })
        }
    },
 })

